import React, { useState, useRef, useEffect } from "react";
import { appConstant } from "config/constant";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PersonIcon from '@mui/icons-material/Person';
import 'styles/scora.css'

export default function Navbar(props) {
  const { isLogin, logout } = props.useSession();
  const { cartItems } = props.useShoppingCart();

  const { navigate } = props.useRouter();
  const [addShowClass, setAddShowClass] = useState('');
  const [activeLink, setActiveLink] = useState('');

  useEffect(() => {

  }, []);

  const handleSignOut = (e) => {
    e.stopPropagation();
    e.preventDefault();

    logout();
    document.location = "/";
  };

  // Adds and removes the 'show' class
  const toggleShowClass = () => {
    setAddShowClass((prevClass) => (prevClass === 'show' ? '' : 'show'));
  };

  // Handles routes when a user clicks on a navbar link
  const handleClick = (path) => {
    navigate(path);
  };

  let windowPath = window.location.pathname;

  // Sets the active link for the navbar
  useEffect(() => {
    setActiveLink(windowPath)
  }, [windowPath]);

  return (
    <>
      <nav className="d-flex justify-content-center justify-content-md-start position-relative pt-3 pb-1">
        <a className="scora_logo" href="#" onClick={() => handleClick("/scora")}>
          <img src="/scora/dist/img/scora_logo.webp" alt="" style={{ width: '150px' }} />
        </a>

        <div style={{ position: "absolute", top: "2rem", right: "3rem" }}>
          <button type="button" className="btn" onClick={() => handleClick("/scora/cart")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" className="bi bi-cart2" viewBox="0 0 16 16">
            <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l1.25 5h8.22l1.25-5zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
            </svg>
            {cartItems.length > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-8px",
                right: "8px",
                background: "#dc3545",
                color: "#fff",
                borderRadius: "50%",
                padding: "2px 7px",
                fontSize: "0.75rem",
                fontWeight: "bold",
                lineHeight: 1,
                minWidth: "22px",
                textAlign: "center",
                boxShadow: "0 0 2px #0003"
              }}
            >
                {cartItems.length}
            </span>
            )}
          </button>
        </div>
      </nav>
    </>
  );
};